import { useEffect, useState } from "react"
import { useAccount } from "wagmi";
import { getMultiCall, getWeb3Contract } from "../helper/contractHelper";
import { getCurrentChain } from "../helper/functions";
import { CHAIN_INFO } from "../helper/constant";
import nftmasterABI from '../abis/nftmaster.json';


export const useCommonStats = () => {
    const { chainId } = useAccount();
    const [stats, setStats] = useState({
        price: 0,
    });

    let currentChain = getCurrentChain(chainId);
    const sc = getWeb3Contract( nftmasterABI , CHAIN_INFO[currentChain].nft_master, currentChain)

    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    sc.methods.fees(),
                ], currentChain);

                

                setStats({
                    price: data[0] / Math.pow(10,18),
                });
            }
            catch (err) {
                console.log(err.message);
            }
        }

        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chainId]);

    return stats;
}